import { MeiliSearch } from "meilisearch";
import { getGenericContent } from "@/components/shared/utils/utils";
import SearchResultsTemplate from "@/components/shared/components/templates/SearchResultsTemplate";

export default function Search(props) {
  return <SearchResultsTemplate {...props} />;
}

export async function getServerSideProps({ query, locale }) {
  const generic_content = await getGenericContent(locale);

  const term = query.term || "";

  const client = new MeiliSearch({
    host: process.env.SEARCH_HOST,
    apiKey: process.env.SEARCH_API_KEY,
  });

  if (term == "") {
    return {
      props: {
        ...generic_content,
        products: [],
        services: [],
        news: [],
        business_segment: [],
        pages: [],
        companies: [],
        term,
      },
    };
  }
    
  const websiteFilter = `website = '${process.env.NEXT_PUBLIC_STRAPI_CLIENT.replace(/^https?:\/\//, "")}'`;

  const [
    products,
    services,
    resources,
    news,
    business_segment,
    pages,
    companies,
  ] = await Promise.all([
    client.index("product").search(term, { limit: 100, filter: websiteFilter }),
    client.index("service").search(term, { limit: 100, filter: websiteFilter }),
    client.index("resource").search(term, { limit: 100, filter: websiteFilter }),
    client.index("new").search(term, { limit: 100, filter: websiteFilter }),
    client.index("business-segment").search(term, { limit: 100, filter: websiteFilter }),
    client.index("page").search(term, { limit: 100, filter: websiteFilter }),
    client.index("company").search(term, { limit: 100, filter: websiteFilter }),
  ]);
  return {
    props: {
      ...generic_content,
      products: products.hits,
      services: services.hits,
      resources: resources.hits,
      news: news.hits,
      business_segment: business_segment.hits,
      pages: pages.hits,
      companies: companies.hits,
      term,
    },
  };
}
